import OutrightMapper from './outright-mapper';
import OutrightSeasonModel from '../outright-season/outright-season-model';

const OutrightModel = {
    mapper: OutrightMapper,

    players: {
        type: Object,
    },

    seasons: {
        model: OutrightSeasonModel,
        type: Array,
    },
};

export default OutrightModel;
